import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { dualAuthGuard } from './core/auth/dual-auth.guard';
import { ClassesCalendarComponent } from './management/containers/classes-calendar/classes-calendar.component';
import { GcPermissionGuard } from './infrastructure/infrastructure.module';
import { FeaturesResolverService } from './features/features.module';
import { ManagementContextResolverService } from './shared/shared.module';

const routes: Routes = [
    // { path: 'core', loadChildren: './core/core.module#CoreModule' },
    // { path: 'management', loadChildren: './management/management.module#ManagementModule', canActivate: [GcLoggedInGuard] },
    {
        path: '',
        redirectTo: 'management/classes/calendar',
        pathMatch: 'full'
    },
    {
        path: 'configuration',
        loadChildren: () => import('./configuration/configuration.module').then(m => m.ConfigurationModule),
        canActivate: [dualAuthGuard]
    },
    {
        path: 'recordings',
        loadChildren: () => import('./recordings/recordings.module').then(m => m.RecordingsModule),
        canActivate: [dualAuthGuard]
    },
    {
        path: 'playlists',
        loadChildren: () => import('./playlists/playlists.module').then(m => m.PlaylistsModule),
        canActivate: [dualAuthGuard]
    },
    {
        path: 'trainers',
        loadChildren: () => import('@bayclubs/providers-frontend').then(module => module.ProvidersFrontendModule),
        canActivate: [dualAuthGuard, GcPermissionGuard],
        data: {
            expectedPermission: 'Providers.canManageProviders',
            title: 'NavBarMenu.ProvidersListMenuItemLabel'
        },
        resolve: {
            features: FeaturesResolverService,
            context: ManagementContextResolverService
        }
    },
    {
        path: 'observability',
        loadComponent: () => import('@bayclubs/logging').then(m => m.BcObservabilityPanelComponent),
        canActivate: [dualAuthGuard]
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule {}
